import * as T from 'three';
import {RoundedBoxGeometry} from 'three/addons/geometries/RoundedBoxGeometry.js';
export function makeMagnetTool(extent){
 const group=new T.Group(),size=extent*.18;
 // A nickel block with softly machined edges and a recessed pole mark.
 // Broad faces reflect the studio; the shallow bevel catches a thin highlight.
 const shell=new T.Mesh(new RoundedBoxGeometry(size,size*.76,size*.86,5,size*.075),new T.MeshPhysicalMaterial({color:'#d1d5df',metalness:.94,roughness:.24,clearcoat:.08,clearcoatRoughness:.3}));
 const inset=new T.Mesh(new T.CylinderGeometry(size*.18,size*.18,size*.006,32),new T.MeshStandardMaterial({color:'#565969',metalness:.82,roughness:.38}));
 inset.position.y=size*.381;
 const stripe=new T.Mesh(new RoundedBoxGeometry(size*.17,size*.008,size*.028,2,size*.009),new T.MeshStandardMaterial({color:'#e2d6bf',metalness:.78,roughness:.31}));stripe.position.y=size*.386;
 group.add(shell,inset,stripe);group.name='magnet_tool';group.rotation.set(.12,0,-.15);
 for(const mesh of group.children){mesh.userData.magnetTool=true;mesh.castShadow=true;}
 group.userData.dispose=()=>{for(const mesh of group.children){mesh.geometry.dispose();mesh.material.dispose();}};
 return group;
}
const smooth=x=>{x=Math.max(0,Math.min(1,x));return x*x*(3-2*x);};
const mix=(a,b,t)=>a.map((v,i)=>v+(b[i]-v)*smooth(t));
export function createMagnetDemoPath(body,surfacePoints=null){
 const {min,max}=body,e=Math.max(...max.map((v,a)=>v-min[a])),cx=(min[0]+max[0])*.5,h=max[1]-min[1];
 const contact=[cx+e*.12,min[1]+h*.68,max[2]];
 if(surfacePoints?.length){
  let closest=-1,distance=Infinity;
  for(let i=0;i<surfacePoints.length;i+=3){
   const d=(surfacePoints[i]-contact[0])**2+(surfacePoints[i+1]-contact[1])**2+(surfacePoints[i+2]-contact[2])**2;
   if(d<distance){distance=d;closest=i;}
  }
  if(closest>=0)for(let a=0;a<3;a++)contact[a]=surfacePoints[closest+a];
 }
 const near=[contact[0],contact[1],contact[2]+e*.06];
 return {near,lift:[near[0]-e*.28,near[1]+e*.22,near[2]+e*.11]};
}
export function magnetDemoTarget(body,home,time,path=null){
 const {near,lift}=path??createMagnetDemoPath(body);
 if(time<.6)return mix(path?.start??home,near,time/.6);
 if(time<1.15)return near;
 if(time<2)return mix(near,lift,(time-1.15)/.85);
 return mix(lift,home,(time-2)/.7);
}
